module.exports = {
  defaultTitle: 'Arslan Dogar',
  logo: 'https://portfolio.smakosh.com/favicon/favicon-512.png',
  author: 'Arslan Dogar',
  url: 'https://arslandogar.netlify.com/',
  legalName: 'Arslan',
  defaultDescription: 'I’m Arslan and I’m a fullstack javascript developer!',
  socialLinks: {
    twitter: 'http://www.twitter.com/arslanndogar',
    github: 'https://github.com/arslandogar',
    linkedin: 'https://www.linkedin.com/in/ismail-ghallou-630149122/',
    instagram: 'https://instagram.com/smakosh19',
    youtube: 'https://www.youtube.com/user/smakoshthegamer',
    google: 'https://plus.google.com/u/0/+IsmailSmakoshGhallou',
  },
  googleAnalyticsID: 'UA-88875900-4',
  themeColor: '#6b63ff',
  backgroundColor: '#6b63ff',
  social: {
    facebook: 'appId',
    twitter: '@arslanndogar',
  },
  address: {
    city: 'City',
    region: 'Region',
    country: 'Country',
    zipCode: 'ZipCode',
  },
  contact: {
    email: 'email',
    phone: 'phone number',
  },
  foundingDate: '2019',
  recaptcha_key: '6LeGYMQUAAAAAIOWqnQt_sTHXCTgFF6N3BH5hxYw',
};
